<template>
  <div class="box4">
    <pageTitle title text="— 抢占大数据红利，就从Python入局 —" />
    <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
      <swiper-slide>
        <div class="content-box">
          <div class="title">处理大数据，用Python更简单</div>

          <div class="content">
            <div class="demo">
              <div class="icon">
                <img
                  src="../../../assets/coursePage/pythonData/box4/icon1.png"
                  alt
                />
              </div>
              <div class="text">
                较Java/C/C++
                <br />门槛低、入门易
              </div>
            </div>

            <div class="demo">
              <div class="icon">
                <img
                  src="../../../assets/coursePage/pythonData/box4/icon2.png"
                  alt
                />
              </div>
              <div class="text">
                大数据开发
                <br />标准编程语言
              </div>
            </div>
            <div class="demo">
              <div class="icon">
                <img
                  src="../../../assets/coursePage/pythonData/box4/icon3.png"
                  alt
                />
              </div>
              <div class="text">
                Top1
                <br />全球编程语言
              </div>
            </div>
            <div class="demo">
              <div class="icon">
                <img
                  src="../../../assets/coursePage/pythonData/box4/icon4.png"
                  alt
                />
              </div>
              <div class="text">
                Spark官方
                <br />第一推荐编程语言
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="content-box">
          <div class="title">
            各种大数据主流开源框架，相继提供了<br />Python支持
          </div>
          <img src="../../../assets/coursePage/pythonData/box4/right.png" alt />
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination-box4"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box4",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box4 {
  position: relative;
  padding-bottom: 126px;
  width: 100%;
  background: #dbf4ff;
  padding-top: 8px;
  /deep/ .course-title-box {
    .course-text {
      margin-top: 32px;
    }
  }

  .content-box {
    margin: 0 auto;
    margin-top: 48px;
    padding-top: 30px;
    width: 690px;
    height: 520px;
    background-image: linear-gradient(90deg, #f9fdff 0%, #f6fcff 100%);
    box-shadow: 0px 5px 30px 0px rgba(202, 237, 255, 0.82);
    border-radius: 20px;
    text-align: center;
    box-sizing: border-box;
    img {
      margin-top: 24px;
      width: 650px;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      text-align: center;
      font-weight: 500;
      color: #002233;
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0px 50px;
      text-align: center;
      box-sizing: border-box;
      margin-top: 20px;

      .demo {
        flex: 1;
        padding-top: 30px;
        min-width: 50%;
        height: 200px;
        box-sizing: border-box;
        &:nth-child(1) {
        padding-bottom: 20px;
          border-bottom: 1px solid #cceeff;
        }
        &:nth-child(2) {
          border-bottom: 1px solid #cceeff;
          border-left: 1px solid #cceeff;
        }
        &:nth-child(4) {
          border-left: 1px solid #cceeff;
        }
      }
      .icon {
        margin: 0 auto;

        margin-bottom: 20px;
        width: 40px;
        height: 40px;
        img {
          margin-top: 0px;
          width: 100%;
          height: 100%;
        }
      }
      .text {
        font-family: PingFang SC;
        font-size: 26px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 44px;
        letter-spacing: 0px;
        color: #002233;
      }
    }
  }

  .swiper-pagination-box4 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    // margin: 0px 4px;
    width: 20px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
</style>
